/**
 * Builds lookup from geojson-vt feature id (promoteId property) to original GeoJSON feature.
 */
export function buildVtOriginalFeaturesByNumericId(
  fcFeatures: any[],
  idProperty: string,
): Map<number, any> {
  const map = new Map<number, any>();
  for (const f of fcFeatures) {
    const id = Number(f.properties?.[idProperty]);
    if (!Number.isFinite(id)) continue;
    map.set(id, f);
  }
  return map;
}
